import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-bootstrap/Modal";
import { compareAsc, format } from "date-fns";
import moment from "moment";
import DownloadHolidayCom from "./DownloadHolidayCom";
import ReactPaginate from "react-paginate";
import jwt_decode from "jwt-decode";

import LeaveModal from "./LeaveModal";

function EmpLeaveCom() {
  const currYearName = moment().format("Y");

  const get_oermission_data = useSelector((state) => state);

  const navigate = useNavigate();

  const SERVER_URL = process.env.REACT_APP_API_URL;
  const BASE_URL = process.env.REACT_APP_APP_URL;

  const token = JSON.parse(localStorage.getItem("key"));
  const userInfo = jwt_decode(token.value);
  const userId = localStorage.getItem("userId");

  const [holidaylist, setHolidaylist] = useState([]);
  const [modalstatus, setModalstatus] = useState(false);

  const [leave_type, setLeave_type] = useState("0");
  const [fromdate, setFromdate] = useState();
  const [todate, setTodate] = useState();
  const [duration, setDuration] = useState();
  const [half, setHalf] = useState("0");
  const [reason, setReason] = useState();

  const [err, setErr] = useState("");
  const [errmsg, setErrmsg] = useState("");
  const [msg, setMsg] = useState("");
  const [errfromdatemsg, setErrfromdatemsg] = useState("");
  const [errtodatemsg, setErrtodatemsg] = useState("");
  const [durationmsg, setErrDurationmsg] = useState("");
  const [halfdurationmsg, setErrhalfdurationmsg] = useState("");

  const [leave, setLeave] = useState({});
  const [leavelist, setLeavelist] = useState([]);

  const [id, setId] = useState("");
  const [modalcomment, setModalcomment] = useState(false);
  const [att_remark, setAtt_remark] = useState("");
  const [date_select, setDate_select] = useState("");
  const [openModelType, setOpenModelType] = useState("");

  const pagination = useRef();

  const [totalitem, setTotalitem] = useState("");
  const [perPage] = useState(10);
  const [pages, setPages] = useState(1);

  const [availedEl, setAvailedEl] = useState(0);
  const [availedCl, setAvailedCl] = useState(0);
  const [availedSl, setAvailedSl] = useState(0);
  const [availedLwp, setAvailedLwp] = useState(0);

  const [error, setError] = useState(null);

  /*
   * ------------------------------------------------------------
   * Safe number helper
   * ------------------------------------------------------------
   */
  const toNumber = (value, defaultValue = 0) => {
    if (value === null || value === undefined || value === "") {
      return defaultValue;
    }

    const number = Number(value);

    return Number.isFinite(number) ? number : defaultValue;
  };

  /*
   * ------------------------------------------------------------
   * Total leave
   * ------------------------------------------------------------
   */
  const totalLeave =
    leave?.el_leave != null &&
    leave?.cl_leave != null &&
    leave?.sl_leave != null
      ? toNumber(leave.el_leave) +
        toNumber(leave.cl_leave) +
        toNumber(leave.sl_leave)
      : null;

  /*
   * ------------------------------------------------------------
   * Pagination
   * ------------------------------------------------------------
   */
  const setPage = ({ selected }) => {
    setPages(selected + 1);
  };

  /*
   * ------------------------------------------------------------
   * Leave Modal
   * ------------------------------------------------------------
   */
  const HandleLeaveModal = () => {
    setModalstatus(true);
    setOpenModelType("add");
  };

  /*
   * ------------------------------------------------------------
   * Close Modal
   * ------------------------------------------------------------
   */
  const handleClose = () => {
    setModalcomment(false);
    setAtt_remark("");

    setModalstatus(false);

    setErr("");
    setMsg("");
    setErrmsg("");
    setErrfromdatemsg("");
    setErrtodatemsg("");
    setErrDurationmsg("");
    setErrhalfdurationmsg("");

    setReason("");
    setLeave_type("0");
    setId("");

    setFromdate("");
    setTodate("");
    setDuration("");
    setHalf("0");
  };

  /*
   * ------------------------------------------------------------
   * Holiday List
   * ------------------------------------------------------------
   */
  useEffect(() => {
    const controller = new AbortController();

    const getholidayList = async () => {
      try {
        const response = await fetch(
          SERVER_URL + `api/holiday/office-holiday-list`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              authorization: `bearer ${token.value}`,
            },
            signal: controller.signal,
          },
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();

        if (result.status === true) {
          setHolidaylist(Array.isArray(result.result) ? result.result : []);
        }
      } catch (err) {
        if (err.name === "AbortError") {
          console.log("Fetch request was aborted");
        } else {
          setError(err.message || "An error occurred");
        }
      }
    };

    getholidayList();

    return () => {
      controller.abort();
    };
  }, [SERVER_URL, token.value]);

  /*
   * ------------------------------------------------------------
   * Employee Leave Balance
   * ------------------------------------------------------------
   */
  useEffect(() => {
    const controller = new AbortController();

    const getEmpLeave = async () => {
      try {
        const response = await fetch(
          SERVER_URL + `api/attendance/leave-balance-list`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              authorization: `bearer ${token.value}`,
            },
            body: JSON.stringify({
              EmpID: userId,
            }),
            signal: controller.signal,
          },
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();

        if (result.status === true) {
          setLeave(result.data || {});
        }
      } catch (err) {
        if (err.name === "AbortError") {
          console.log("Fetch request was aborted");
        } else {
          setError(err.message || "An error occurred");
        }
      }
    };

    getEmpLeave();

    return () => {
      controller.abort();
    };
  }, [SERVER_URL, token.value, userId]);

  /*
   * ------------------------------------------------------------
   * Leave Count
   * ------------------------------------------------------------
   */
  function getCountLeave(year) {
    fetch(SERVER_URL + `api/leave/leave-emp-count`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        empID: userId,
        currYearName: year,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true && Array.isArray(data.data)) {
          let el = 0;
          let cl = 0;
          let sl = 0;
          let lwp = 0;

          data.data.forEach((item) => {
            const count = toNumber(item.leave_count);

            if (Number(item.leave_type) === 1) {
              el = count;
            }

            if (Number(item.leave_type) === 2) {
              cl = count;
            }

            if (Number(item.leave_type) === 3) {
              sl = count;
            }

            if (Number(item.leave_type) === 4) {
              lwp = count;
            }
          });

          setAvailedEl(el);
          setAvailedCl(cl);
          setAvailedSl(sl);
          setAvailedLwp(lwp);
        }
      })
      .catch((err) => {
        console.error("getCountLeave error:", err);
      });
  }

  /*
   * ------------------------------------------------------------
   * Leave List
   * ------------------------------------------------------------
   */
  function getLeaveList() {
    fetch(
      SERVER_URL + `api/leave/leave-history?page=${pages}&&empID=${userId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        setLeavelist(Array.isArray(data.data) ? data.data : []);
        setTotalitem(toNumber(data.leaveTotal));
      })
      .catch((err) => {
        console.error("getLeaveList error:", err);
        setLeavelist([]);
        setTotalitem(0);
      });
  }

  /*
   * ------------------------------------------------------------
   * Load Leave History
   * ------------------------------------------------------------
   */
  useEffect(() => {
    getLeaveList();
    getCountLeave(currYearName);
  }, [pages]);

  /*
   * ------------------------------------------------------------
   * Date Converter
   * ------------------------------------------------------------
   */
  const dateConverter2 = (startDate, timeEnd) => {
    const newStartDate = new Date(startDate);
    const newEndDate = new Date(timeEnd);

    if (
      Number.isNaN(newStartDate.getTime()) ||
      Number.isNaN(newEndDate.getTime())
    ) {
      return 0;
    }

    return moment(newStartDate).diff(newEndDate, "days") + 1;
  };

  /*
   * ------------------------------------------------------------
   * Working Days Converter
   * ------------------------------------------------------------
   */
  const dateConverter = (startDate, endDate) => {
    const newStartDate = new Date(startDate);
    const newEndDate = new Date(endDate);

    if (
      Number.isNaN(newStartDate.getTime()) ||
      Number.isNaN(newEndDate.getTime())
    ) {
      return "0 Day";
    }

    let count = 0;
    const current = new Date(newStartDate);

    while (current <= newEndDate) {
      const day = current.getDay();

      // 0 = Sunday, 6 = Saturday
      if (day !== 0 && day !== 6) {
        count++;
      }

      current.setDate(current.getDate() + 1);
    }

    return count > 1 ? `${count} Days` : `${count} Day`;
  };

  /*
   * ------------------------------------------------------------
   * Leave Type
   * ------------------------------------------------------------
   */
  const leave_type_arr = [
    "",
    "Earned Leave",
    "Casual Leave",
    "Sick Leave",
    "Leave Without Pay",
    "Vacation Holiday",
  ];

  /*
   * ------------------------------------------------------------
   * Edit
   * ------------------------------------------------------------
   */
  const HandleEdit = (leaveId) => {
    setId(leaveId);
    setOpenModelType("edit");
    setModalstatus(true);
  };

  /*
   * ------------------------------------------------------------
   * Delete
   * ------------------------------------------------------------
   */
  const HandleDelete = (leaveId) => {
    fetch(SERVER_URL + `api/leave/leave-delete`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        leaveId: leaveId,
        statusValue: "1",
        requestedBy: userId,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          getLeaveList();
          getCountLeave(currYearName);
        }
      })
      .catch((err) => {
        console.error("HandleDelete error:", err);
      });
  };

  /*
   * ------------------------------------------------------------
   * Get Rejection Remark
   * ------------------------------------------------------------
   */
  const handleMSG = (leaveId) => {
    fetch(SERVER_URL + `api/leave/get-leave-remark`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        leaveId: leaveId,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          setAtt_remark(data.data?.remark || "");
        } else {
          setAtt_remark("");
        }
      })
      .catch((err) => {
        console.error("handleMSG error:", err);
        setAtt_remark("");
      });

    setModalcomment(true);
  };

  /*
   * ------------------------------------------------------------
   * Status
   * ------------------------------------------------------------
   */
  const renderStatus = (status) => {
    if (Number(status) === 0) {
      return <span className="badge bg-warning">Pending</span>;
    }

    if (Number(status) === 1) {
      return <span className="badge bg-success">Approved</span>;
    }

    if (Number(status) === 3) {
      return <span className="badge bg-danger">Reject</span>;
    }

    return "";
  };

  /*
   * ------------------------------------------------------------
   * Actions
   * ------------------------------------------------------------
   */
  const renderActions = (item) => {
    if (item.request_type == 2 && item.status == 0) {
      return null;
    }

    if (item.request_type != 2 && item.status == 0) {
      return (
        <>
          {/* Edit button can be enabled if required */}
          {/*
          <button
            onClick={() => HandleEdit(item?.id)}
            className="btn_7 mr03"
          >
            Edit
          </button>
          */}

          <button className="btn_8" onClick={() => HandleDelete(item?.id)}>
            Delete
          </button>
        </>
      );
    }

    if (item.status == 3) {
      return (
        <span className="btn_5" onClick={() => handleMSG(item.id)}>
          Reason
        </span>
      );
    }

    return null;
  };

  /*
   * ------------------------------------------------------------
   * Render
   * ------------------------------------------------------------
   */
  return (
    <div className="container-fluid">
      {/* Rejection Remark Modal */}
      <Modal show={modalcomment} size="sm" id="rejectmodal">
        <div className="modalheader">
          <button
            type="button"
            className="float-end btn_close"
            onClick={handleClose}
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i className="icon icon-cross fw-bold"></i>
          </button>

          <img src="assets/images/cross_icon.png" alt="" />

          <span className="arrow_down"></span>
        </div>

        <div className="modal-body">
          <div
            className="dash_white_box_ttl text-left mb10"
            id="exampleModalLabel"
          >
            Reason of Rejection
          </div>

          <div className="mb-2">
            <textarea
              value={att_remark}
              className="form-control"
              readOnly
              placeholder=""
            />
          </div>
        </div>
      </Modal>

      {/* Leave Modal */}
      <LeaveModal
        modal_type={openModelType}
        modalstatus={modalstatus}
        setModalstatus={setModalstatus}
        handleClose={handleClose}
        getLeaveList={getLeaveList}
        leave_id={id}
      />

      {/* Page Title */}
      {userInfo.UserType === 1 ? (
        <div className="dash_ttl">
          <button className="btn_5 mr10 float-end" onClick={HandleLeaveModal}>
            Apply Leave
          </button>
          Leave
        </div>
      ) : (
        ""
      )}

      {/* Breadcrumb */}
      <div className="crumbs">
        <ul id="breadcrumbs" className="breadcrumb">
          <li>
            <Link to="/dashboard">Dashboard</Link>
          </li>

          <li className="current">
            <span>/</span> Leave
          </li>
        </ul>
      </div>

      <div className="row mb30">
        {/* LEFT */}
        <div className="col-md-8">
          {/* Leave Balance */}
          {userInfo.UserType === 1 ? (
            <div className="dash_white_box2 mb20 p20">
              <div className="dash_white_box_ttl">Leave Balance</div>

              <ul className="leavebalance_wrp">
                {/* Carry Forward */}
                <li className="leavebalance_blk lwp">
                  <div className="leavebalance_num_blk leave_lwp">
                    <div className="leavebalance">
                      {leave?.carry_forward != null
                        ? leave.carry_forward
                        : "N/A"}
                    </div>
                  </div>

                  <div className="leavebalance_ttl">Carry Forward</div>
                </li>

                {/* Earned Leave */}
                <li className="leavebalance_blk cl">
                  <div className="leavebalance_num_blk leave_cl">
                    <div className="leavebalance">
                      {leave?.el_leave != null ? leave.el_leave : "N/A"}
                    </div>
                  </div>

                  <div className="leavebalance_ttl">Earned Leave - EL</div>

                  <div className="leavebalance_hover">
                    <div className="leavebalance_ttl">Balance Leave</div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Opening
                      </div>

                      <div>
                        {leave?.el_leave != null
                          ? toNumber(leave.el_leave) - 1.25
                          : "N/A"}
                      </div>
                    </div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Accrued
                      </div>

                      <div>1.25</div>
                    </div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Availed
                      </div>

                      <div>{availedEl}</div>
                    </div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Total EL
                      </div>

                      <div>
                        {leave?.el_leave != null
                          ? toNumber(leave.el_leave)
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                </li>

                {/* Casual Leave */}
                <li className="leavebalance_blk sl">
                  <div className="leavebalance_num_blk leave_sl">
                    <div className="leavebalance">
                      {leave?.cl_leave != null ? leave.cl_leave : "N/A"}
                    </div>
                  </div>

                  <div className="leavebalance_ttl">Casual Leave - CL</div>

                  <div className="leavebalance_hover">
                    <div className="leavebalance_ttl">Balance Leave</div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Opening
                      </div>

                      <div>
                        {leave?.cl_leave != null
                          ? toNumber(leave.cl_leave)
                          : "N/A"}
                      </div>
                    </div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Accrued
                      </div>

                      <div>0.5</div>
                    </div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Availed
                      </div>

                      <div>{availedCl}</div>
                    </div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Total CL
                      </div>

                      <div>
                        {leave?.cl_leave != null
                          ? toNumber(leave.cl_leave)
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                </li>

                {/* Sick Leave */}
                <li className="leavebalance_blk sl">
                  <div className="leavebalance_num_blk leave_sl">
                    <div className="leavebalance">
                      {leave?.sl_leave != null ? leave.sl_leave : "N/A"}
                    </div>
                  </div>

                  <div className="leavebalance_ttl">Sick Leave - SL</div>

                  <div className="leavebalance_hover">
                    <div className="leavebalance_ttl">Balance Leave</div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Opening
                      </div>

                      <div>
                        {leave?.sl_leave != null
                          ? toNumber(leave.sl_leave) - 0.5
                          : "N/A"}
                      </div>
                    </div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Accrued
                      </div>

                      <div>0.5</div>
                    </div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Availed
                      </div>

                      <div>{availedSl}</div>
                    </div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Total SL
                      </div>

                      <div>
                        {leave?.sl_leave != null
                          ? toNumber(leave.sl_leave)
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                </li>

                {/* TOTAL LEAVE */}
                <li className="leavebalance_blk el">
                  <div className="leavebalance_num_blk leave_el">
                    <div className="leavebalance">
                      {totalLeave !== null ? totalLeave : "N/A"}
                    </div>
                  </div>

                  <div className="leavebalance_ttl">Total Leave</div>
                </li>

                {/* LWP */}
                <li className="leavebalance_blk py">
                  <div className="leavebalance_num_blk leave_py">
                    <div className="leavebalance">N/A</div>
                  </div>

                  <div className="leavebalance_ttl">Leave without pay</div>

                  <div className="leavebalance_hover">
                    <div className="leavebalance_ttl">Balance Leave</div>

                    <div className="leavebalance_ttl">
                      <div>
                        <span></span>
                        Availed
                      </div>

                      <div>{availedLwp}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          ) : (
            ""
          )}

          {/* Leave History */}
          <div className="contentwrp content_wrp">
            <div className="tab_wrapper tab_wrapper1">
              <div className="dash_white_box_ttl">Leave History</div>

              <table className="table_style_1">
                <thead>
                  <tr>
                    <th>Leave Type</th>
                    <th>Date</th>
                    <th>Count</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {leavelist?.map((item, ind) => {
                    const fromDate = new Date(item?.from_date);
                    const toDate = new Date(item?.to_date);

                    const validFromDate = !Number.isNaN(fromDate.getTime());

                    const validToDate = !Number.isNaN(toDate.getTime());

                    return (
                      <tr key={item?.id || ind + 1}>
                        {/* Leave Type */}
                        <td>
                          {item?.request_type == 2 && (
                            <span className="avatar_icon">Rg</span>
                          )}

                          {item?.request_type != 2 && (
                            <span className="avatar_icon">
                              {leave_type_arr[Number(item?.leave_type)]
                                ? leave_type_arr[Number(item?.leave_type)]
                                    .match(/(\b\S)?/g)
                                    .join("")
                                    .match(/(^\S|\S$)?/g)
                                    .join("")
                                    .toUpperCase()
                                : ""}
                            </span>
                          )}
                        </td>

                        {/* Date */}
                        <td>
                          {item?.request_type != 2 && (
                            <span>
                              {validFromDate
                                ? moment(item.from_date).format("DD MMM, yyyy")
                                : "N/A"}

                              {" - "}

                              {validToDate
                                ? moment(item.to_date).format("DD MMM, yyyy")
                                : "N/A"}
                            </span>
                          )}

                          {item?.request_type == 2 && (
                            <span>
                              {validFromDate
                                ? moment(item.regularize_date).format(
                                    "DD MMM, yyyy",
                                  )
                                : "N/A"}

                              {" ("}

                              {item?.start_time
                                ? moment(item.start_time, ["HH:mm"]).format(
                                    "hh:mm A",
                                  )
                                : "--"}

                              {" - "}

                              {item?.end_time
                                ? moment(item.end_time, ["HH:mm"]).format(
                                    "hh:mm A",
                                  )
                                : "--"}

                              {")"}
                            </span>
                          )}
                        </td>

                        {/* Count */}
                        <td>
                          {item?.request_type == 2 &&
                          validFromDate &&
                          validToDate
                            ? dateConverter(
                                format(fromDate, "yyyy-MM-dd"),
                                format(toDate, "yyyy-MM-dd"),
                              )
                            : ""}

                          {item?.request_type == 3 &&
                          Number(item?.duration_type) === 2
                            ? "0.5 Half"
                            : ""}

                          {item?.request_type == 3 &&
                          Number(item?.duration_type) === 1 &&
                          validFromDate &&
                          validToDate
                            ? dateConverter(
                                format(fromDate, "yyyy-MM-dd"),
                                format(toDate, "yyyy-MM-dd"),
                              )
                            : ""}
                        </td>

                        {/* Reason */}
                        <td>{item?.user_remarks || ""}</td>

                        {/* Status */}
                        <td>{renderStatus(item?.status)}</td>

                        {/* Actions */}
                        <td>{renderActions(item)}</td>
                      </tr>
                    );
                  })}
                </tbody>

                <tfoot>
                  <tr>
                    <td colSpan="8">
                      <ReactPaginate
                        ref={pagination}
                        pageCount={
                          totalitem > 0
                            ? Math.ceil(Number(totalitem) / Number(perPage))
                            : 0
                        }
                        pageRangeDisplayed={4}
                        marginPagesDisplayed={1}
                        onPageChange={setPage}
                        containerClassName="pagination"
                        activeClassName="active"
                        pageLinkClassName="page-link"
                        breakLinkClassName="page-link"
                        nextLinkClassName="page-link"
                        previousLinkClassName="page-link"
                        pageClassName="page-item"
                        breakClassName="page-item"
                        nextClassName="page-item"
                        previousClassName="page-item"
                        previousLabel={<>&laquo;</>}
                        nextLabel={<>&raquo;</>}
                      />
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="col-md-4">
          <div className="dash_white_box2 mb20">
            <div className="dash_white_box_ttl">
              <DownloadHolidayCom /> List of Holidays
            </div>

            <ul className="holiday_list_wrp">
              {holidaylist?.map((item, ind) => {
                const holidayDate = new Date(item?.holiday_date);

                const validHolidayDate = !Number.isNaN(holidayDate.getTime());

                return (
                  <li key={item?.id || ind + 1} className="holiday_list_blk">
                    <div className="holiday_list">
                      <img src="assets/images/holidays.png" alt="Holiday" />

                      <span>
                        {validHolidayDate
                          ? moment(item.holiday_date).format("DD MMM, yyyy")
                          : "N/A"}
                      </span>

                      <span>
                        {validHolidayDate
                          ? moment(item.holiday_date).format("dddd")
                          : ""}
                      </span>
                    </div>

                    <div className="holiday_list">
                      <span>{item?.level || ""}</span>

                      <span>
                        {Number(item?.holiday_type) === 1
                          ? "Restricted Holiday"
                          : Number(item?.holiday_type) === 3
                            ? "National Holiday"
                            : Number(item?.holiday_type) === 2
                              ? "Gazetted Holiday"
                              : item?.holiday_type || ""}
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>

            <p className="fs12">
              There are three National Holidays in India, 26th January, 15th
              August and 2nd October and there is a Major festivals like Holi
              and Diwali
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmpLeaveCom;
